module.exports = __webpack_public_path__ + "static/media/banner_oficinas.02ad8da7.webp";